import { createInjectionKey as e } from "./ghl-ui.es896.js";
const t = e("n-popselect");
export {
  t as popselectInjectionKey
};
